import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'

import axios from "axios";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { Container, Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import './Css/StampCard.css'

import Stamp from '../Stamp/Index.js';
import RecommendBooks from '../RecommendBooks/Index';
import TrainingList from '../TrainingList/Index';
import { CSVLink, CSVDownload } from "react-csv";

import PinkStamp from '../../img/pinkStamp.png';
import BlueStamp from '../../img/blueStamp.png';
import GreenStamp from '../../img/greenStamp.png';
import RedStamp from '../../img/redStamp.png';
import YellowStamp from '../../img/yellowStamp.png';
import PurpleStamp from '../../img/purpleStamp.png';
import moment from 'moment';

import Template1 from '../../file/推薦図書感想文.xlsx';
import Template2 from '../../file/社内研修受講報告書.xlsx';


moment.locale("ja", {
  weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
});

function getDate() {
  var today = new Date()
  var date = today.getFullYear() + "年" + (today.getMonth() + 1) + "月" + today.getDate() + "日"
  return date
}


function StampCard() {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#0971f1',
        darker: '#053e85',
      },
      neutral: {
        main: '#357ebd',
        // main: '#428bca',
        contrastText: '#fff',
      },
    },
  });
  const authentication = useContext(Authentication);

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  // const handleClose = () => setOpen1(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);

  const [season, setSeason] = useState(0);
  const [all, setall] = useState(0);
  const [stamps, setStamps] = useState(false);
  const [StampSheets, setStampSheets] = useState([]);
  const [userId, setuserId] = useState("");
  const [Csv, setCsv] = useState();

  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/training/points/csv`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/csv`;
    axios.post(url).then((abc) => {
      setCsv(abc.data);
    });
  }, []);



  const download = (id) => {
    // let url = `http://localhost:5000/v1/training/files/get_file/` + id;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/files/get_file/` + id;
    axios.get(url).then((r) => {
      // console.log(r.data);
      r.data.forEach(e => {
        // let url2 = `http://localhost:5000/v1/training/files/download/` + e.name;
        let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/files/download/` + e.name;
        axios.get(url2).then((file) => {
          const a = document.createElement('a');
          a.download = e.name;
          a.href = file.config.url;
          a.click();
        });
      });
    });
  }



  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;
    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {

      setuserId(response.data.id)
      // let url = `http://localhost:5000/v1/training/points/my_point/` + response.data.id;
      let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/my_point/` + response.data.id;
      axios.get(url).then((abc) => {
        setSeason(abc.data.season)
        setall(abc.data.all)
        setStamps(abc.data.stamps)
        setStampSheets(abc.data.stamp_sheets)
      });
    });
  }, []);

  if (!stamps) return null;

  return (
    <Box className="App" id="content" style={{ paddingTop: 60 }}>
      <Grid container sx={{ justifyContent: 'center', mt: 0 }}>
        <Grid item xs={4.5} sx={{ backgroundColor: 'white', borderRadius: 1, mr: 1, pt: 3, pl: 2, pr: 2, pb: 2 }}>
          <Container sx={{ display: 'inline-flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: 28, fontWeight: 'bold' }} gutterBottom>スタンプカード</Typography>
            <FormControl sx={{ width: 200 }}>
              <InputLabel id="demo-simple-select-label">期間</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                defaultValue={1}
                label="期間"
                // onChange={handleChange}
                size='small'
              >
                {/* <MenuItem value={1}>2022年(4月～12月)</MenuItem> */}
                <MenuItem value={1}>2023年(4月～12月)</MenuItem>
              </Select>
            </FormControl>
          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ display: 'inline-flex', justifyContent: 'space-between', mt: 2 }}>
            <Container sx={{ display: 'inline-flex' }}>
              <Typography sx={{ fontSize: 18, mt: 'auto', mb: 'auto' }}>今期保有ポイント</Typography>
              <Typography sx={{ fontSize: 36, fontWeight: 'bold', pb: 1, ml: 1, mr: 1 }}>{season}</Typography>
              <Typography sx={{ fontSize: 20, mt: 'auto', mb: 'auto' }}>pt</Typography>
            </Container>
            <Container sx={{ display: 'inline-flex' }}>
              <Typography sx={{ fontSize: 18, mt: 'auto', mb: 'auto' }}>通算累計ポイント</Typography>
              <Typography sx={{ fontSize: 36, fontWeight: 'bold', pb: 1, ml: 1, mr: 1 }}>{all}</Typography>
              <Typography sx={{ fontSize: 20, mt: 'auto', mb: 'auto' }}>pt</Typography>
            </Container>
            {Csv ?
              <Button variant="contained" size='small' style={{height:40}}>
                <CSVLink style={{ textDecoration: "none", color: "white" }} filename="stamp.csv" data={Csv}>集計表</CSVLink></Button> : ""}
          </Container>
          <Container sx={{ textAlign: 'right', mb: 1 }}>
            <Typography>{getDate()}時点</Typography>


          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ display: 'inline-flex', mb: 2 }}>
            <Container style={{ padding: 0 }}>
              <img src={PinkStamp} alt="pink_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>通信講座終了</Typography>
              <Typography sx={{ fontSize: 12, mt: 3 }}>開催期間月数pt</Typography>
            </Container>
            <Container style={{ padding: 0 }}>
              <img src={BlueStamp} alt="blue_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>通信講座終了後<br />社内研修実施</Typography>
              <Typography sx={{ fontSize: 14, mt: 0.8 }}>5pt</Typography>
            </Container>
            <Container style={{ padding: 0 }}>
              <img src={GreenStamp} alt="green_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>社外研修受講後<br />社内研修実施</Typography>
              <Typography sx={{ fontSize: 14, mt: 0.8 }}>5pt</Typography>
            </Container>
            <Container style={{ padding: 0 }}>
              <img src={RedStamp} alt="red_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>得意分野の<br />社内研修実施</Typography>
              <Typography sx={{ fontSize: 14, mt: 0.8 }}>5pt</Typography>
            </Container>
            <Container style={{ padding: 0 }}>
              <img src={YellowStamp} alt="yellow_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>研修受講<br />報告書提出</Typography>
              <Typography sx={{ fontSize: 14, mt: 0.8 }}>1pt</Typography>
            </Container>
            <Container style={{ padding: 0 }}>
              <img src={PurpleStamp} alt="purple_stamp" width={80} />
              <Typography sx={{ fontSize: 12 }}>推薦図書<br />感想文提出</Typography>
              <Typography sx={{ fontSize: 14, mt: 0.8 }}>2pt</Typography>
            </Container>
          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ mb: 2 }}>
            <Typography className='indent' sx={{ fontSize: 12, textAlign: 'left' }}>
              ※通信教育はHSワークフローで本人が申請を行い、会社から申込を行う。受講終了後は、修了証明を管理者に渡す。
            </Typography>
            <Typography className='indent' sx={{ fontSize: 12, textAlign: 'left' }}>
              ※課題図書については自己負担。感想文を提出後、ポイント付与。
            </Typography>
            <Typography className='indent' sx={{ fontSize: 12, textAlign: 'left' }}>
              ※社外研修については、役員及び部門長の推薦で参加。会社が申込を行う。
            </Typography>
          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: 20, textAlign: 'left', color: '#357ebd', fontWeight: 'bold' }}>
              年間表彰（4月～12月対象）
            </Typography>
            <Typography className='indent' sx={{ fontSize: 15, textAlign: 'left' }}>
              社内教育訓練優秀社員賞　最低基準スタンプ15pt以上
            </Typography>
            <Typography className='indent' sx={{ fontSize: 15, textAlign: 'left' }}>
              1位：2万円　2位：1.5万円　3位：1万円　4位：5千円　5位：3千円
            </Typography>
          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ mb: 2 }}>
            <Typography sx={{ fontSize: 20, textAlign: 'left', color: '#357ebd', fontWeight: 'bold' }}>
              通算累計ポイント：昇格時の判定基準（2024年～）
            </Typography>
            <Container sx={{ display: 'inline-flex' }} style={{ paddingLeft: 0 }}>
              <Typography sx={{ fontSize: 16, mt: 'auto', mb: 'auto' }}>スタンプ</Typography>
              <Typography sx={{ fontSize: 32, fontWeight: 'bold', pb: 1, ml: 2, mr: 1 }}>20</Typography>
              <Typography sx={{ fontSize: 16, mt: 'auto', mb: 'auto' }}>pt 以上</Typography>
            </Container>
            <Typography className='indent' sx={{ fontSize: 12, textAlign: 'left' }}>
              ※昇格基準は別途評価基準の通り。
            </Typography>
            <Typography className='indent' sx={{ fontSize: 12, textAlign: 'left' }}>
              ※起算は2023年4月から(昇格前等級の在級6年間の累積数とする)
            </Typography>
          </Container>
          <Container sx={{ mb: 2 }}>
            <ThemeProvider theme={theme}>
              <Button color="neutral" variant="contained" sx={{ width: 165, height: 55, mr: 3 }} onClick={handleOpen1}>
                推薦図書はこちら
              </Button>
              <RecommendBooks open={open1} setOpen={setOpen1} />
              <Button color="neutral" variant="contained" sx={{ width: 165, height: 55 }} onClick={handleOpen2}>
                研修一覧はこちら
              </Button>
              <TrainingList open={open2} setOpen={setOpen2} />
            </ThemeProvider>
          </Container>
          <Container sx={{ mb: 2 }}>
            <ThemeProvider theme={theme}>
              <a href={Template1} target="_blank">
              <Button color="success" variant="contained" sx={{ width: 165, height: 30, mr: 3 }}>
                推薦図書感想文
              </Button>
              </a>
              <a href={Template2} target="_blank">
              <Button color="success" variant="contained" sx={{ width: 165, height: 30 }}>
                社内研修受講報告書
              </Button>
              </a>
            </ThemeProvider>
          </Container>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ mb: 1 }}>
            <Typography sx={{ fontSize: 20, textAlign: 'left', color: '#357ebd', fontWeight: 'bold' }}>
              過去の提出履歴
            </Typography>
            <TableContainer component={Paper} square elevation={0} align="center" sx={{ maxHeight: 110 }}>
              <Table aria-label="simple table">
                <TableBody>
                  {stamps.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{moment(row.training_day ? row.training_day : row.grant_at).format('YYYY年MM月DD日(ddd)')}</TableCell>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{row.category_title}</TableCell>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{row.title}</TableCell>
                      <TableCell sx={{ width: 25, border: 1, p: 0.5, textAlign: 'center' }}>
                        <IconButton onClick={() => download(row.id)} sx={{ p: 0 }}>
                          <DownloadIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        </Grid>
        <Grid item xs={7.2} sx={{ backgroundColor: '#F4EBC3', borderRadius: 1, pl: 7, pr: 7 }}>
          <Grid container className='grid_scroll1' sx={{ mt: 5, justifyContent: 'center' }}>

            {[...Array(30)].map(function (v, i) {
              return <Grid item md={2.4} xs={6} sx={{ position: 'relative' }}>
                <Box sx={{ backgroundColor: 'white', width: 150, height: 150, mt: 3 }}>
                  <Typography sx={{ color: 'gray', fontSize: 26, textAlign: 'left', ml: 1 }}>{i + 1}</Typography>
                  {i == 14 ? <Typography sx={{ color: 'darkgray', fontSize: 30, fontWeight: 'bold', textAlign: 'center', letterSpacing: 2, mt: 2, rotate: '-10deg' }}>CLEAR!</Typography> : ""}
                </Box>
                {StampSheets[i] ?
                  <Box style={{ position: 'absolute', top: 30, left: 10 }}>
                    <Stamp data={{ num: i, color: StampSheets[i].color, date: moment(StampSheets[i].training_day ? StampSheets[i].training_day : StampSheets[i].grant_at).format('M月D日'), content: StampSheets[i].title }} />
                  </Box> : ""}
              </Grid>
            }, this)}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StampCard;
